// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"a2c1eae8","187":"13301d96","247":"ebd62c8a","454":"b5996c20","457":"61ea17ee","825":"556f5ecb"}[chunkId] + ".chunk.css";
};